import gql from "graphql-tag";

export const REFERRAL = gql`
  query referral($code: String!) {
    referral(code: $code){
      id
      owner {
        id
        firstName
        lastName
      }
    }
  }
`;

export const SHOP_FOR_INVITE = gql`
  query shopForInvite {
    shop {
      signupPointAmount
    }
  }
`;
